import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConceptContactListComponent } from './conceptcontact-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { ConceptContactService } from './conceptcontact.service';
import { ConceptContactModel } from './conceptcontact.model';

@Component({
    selector: 'convfact-conceptcontactdelete',
    templateUrl: './conceptcontact-dialog-delete.component.html',
    styleUrls: ['./conceptcontact.component.css'],
    standalone: false
})

export class ConceptContactDialogDeleteComponent {
    uid: string = this.data.uid;
    type: string = this.data.type;
    error_msg: string;
    error = false;
    conceptcontact: ConceptContactModel;

    constructor(
        public dialogRef: MatDialogRef<ConceptContactListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public conceptcontactService: ConceptContactService
    ) { }

    delete() {
        this.conceptcontactService.deleteData(this.uid);
        this.error = true;
    }

    closeDialog() {
        this.dialogRef.close();
    }

}
